import React from "react";
import "./Banner.scss";
import { Link } from "react-router-dom";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { handleScroll, whatsAppBotListener } from "../../utils/Utils";
import { CONTACTUS_SECTION_ID, PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from '../../assets/rohan-systems-pics/logo.png';

const Banner = () => {
    return (
        <section
            id="banner-section"
            className="section-bg home-bg banner-section"
        >
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container banner-text-div">
                        <div className="row">
                            <div className="col-lg-6 heading-text-div">
                                <div
                                    className="banner-text"
                                    data-aos="fade-up"
                                    data-aos-duration="1000"
                                >
                                    <h1 className="banner-para">Building Trust Through Technology & Security</h1>
                                    <p className="para-trust">
                                        {/* <span className="clinic-name-text">
                                            Ivory Multispeciality Dental Clinic
                                        </span> */}
                                        we provide comprehensive IT solutions, from laptops, desktops, and accessories to expert repair services.
                                        Our advanced CCTV and security systems ensure reliable protection for homes and businesses. 
                                        With end-to-end technology and security services, we deliver seamless support you can trust
                                    </p>

                                    <div className="banner-bottom">
                                        <div className="theme-btn">
                                            <Link onClick={() => handleScroll(CONTACTUS_SECTION_ID)}>
                                            Get a Quotation
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div
                                    className="banner-img-area"
                                    data-aos="fade-up"
                                    data-aos-duration="2000"
                                    data-aos-delay="0"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* What's app bot section */}
            <FloatingWhatsApp
                avatar={clinicIcon}
                notification={false}
                accountName="Rohan Sytems"
                phoneNumber={PHONE_NUMBER}
                onSubmit={(e) => {
                    whatsAppBotListener(e.target[0].value);
                }}
            />
        </section>
    );
};

export default Banner;
